import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, FormControl, ControlLabel, Button, FormGroup, Form, Checkbox, Modal, OverlayTrigger, Tooltip, Glyphicon } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {ToastContainer, ToastStore} from 'react-toasts';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Datetime from 'react-datetime';//has time but no min/maxDate
import Popup from "reactjs-popup";

import _ from 'underscore';

import UsersService from "../../services/users-service";
import IncidentService from '../../services/incidents-service';
import UtilsService from '../../services/utils-service';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import GLOBALS from '../../utils/Constants';
import moment from 'moment';
import './style.css';

import { saveAs } from 'file-saver';
import JSZip from 'jszip';

import Loading from "../../components/loading";


//For Massive Forms. Has better control over text and stuff supposedly.
var pdfMake = require('pdfmake/build/pdfmake.js');
var vfs_fonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = vfs_fonts.pdfMake.vfs;

class IncidentArchive extends Component {

    csv_report = null;

    constructor(props, context) {
        super(props, context);

    		const credentials =  UsersService.sharedInstance.getStoredCredentials().loginResponse;
    		const license = credentials.data[0].User_License;

        this.state = {
	          token: credentials.token_data.token,
            auth_username: credentials.data[0].User_ID,
            sub_user_id: credentials.data[0].recno,
            license: license,
            show: false,
            reports: [],
            selectAll: false,
            itemToEditIndex: null,
            guiltyObject: null, //For Deletion
            showConfirmationModal: false ,
            showInfoModal: false,
            showMergeModal: false,
            incidents: [],
            selectedIncidents: [],
            selectedIncident: null,
            liveNationPDFDocDefinition: [],
            isUpdatingLinkedIncidents: false,
            linkingMessage: "Linking Incidents...",
            isMergingIncidents: false,
            isDownloadingPDF:false,
            historyData:[],
            //loadingHistory: false
        }

        this.handleCheckBoxTick = this.handleCheckBoxTick.bind(this);

        this.fetchIncidentInfo = this.fetchIncidentInfo.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
        this.onLinkIncidents = this.onLinkIncidents.bind(this);
        this.renderLinkIncidentAction = this.renderLinkIncidentAction.bind(this);
        this.renderLinkModal = this.renderLinkModal.bind(this);
        this.downloadArchivePDF = this.downloadArchivePDF.bind(this);
        this.countSelectedIncidents = this.countSelectedIncidents.bind(this);
        this.fetchIncidentHistory = this.fetchIncidentHistory.bind(this);

        this.options = {
            onRowClick: (row) => {
              this.setState({
                selectedItem: this.fetchIncidentInfo(row.id),
                showInfoModal: true,
                historyData: []
              })
              this.fetchIncidentHistory(row.id)
            },
            hideSizePerPage: true,
            defaultSortName: 'time',  // default sort column name
            defaultSortOrder: 'desc'  // default sort order
        }
        this.linkIncidentOptions = {
            onRowClick: (row) => { },
            hideSizePerPage: true,
            defaultSortName: 'time',  // default sort column name
            defaultSortOrder: 'asc'  // default sort order
        }

        this.incidentHistoryOptions = {
            onRowClick: (row) => { this.setState({selectedItem: this.state.selectedItem, showInfoModal: true, showIncidentHistoryModal: false}); ToastStore.warning("Replace preview modal content with selected version/history! (Under Construction)", 5000)},
            hideSizePerPage: true,
            defaultSortName: 'date',  // default sort column name
            defaultSortOrder: 'desc',  // default sort order
            noDataText: "No history found."
        }


    }

    componentWillMount(){
    }

    componentWillReceiveProps(props){
        if (this.props.onDeleteMode == true){
            this.performActualDeletion();
        }

        else {
            //this.fetchIncidents();
        }
    }

    render() {
      var itemToEditIndex = this.state.itemToEditIndex;

      return(
          <div className="reports-main-content">
              <div className="incidents-table">
                  {
                    this.props.incidentType == "live_nation" ? this.renderFilters() : null
                  }
                  {
                      this.props.incidentType == "live_nation" ? this.renderLiveNationArchiveTable() : this.renderStandardIncidentsArchiveTable()
                  }
              </div>

              <Modal style={{marginTop: "10%"}}
				            show={this.state.showConfirmationModal}
                  onExit={()=>{this.setState({showConfirmationModal: false, guiltyObject: null})}}>
                  <Modal.Header>
                    	<b style={{fontSize: 20}}>Confirm Deletion</b>
                  </Modal.Header>
                  <Modal.Body>
                      <div style={{textAlign: 'center'}}>Are you sure you want to delete these incidents?</div>
                  </Modal.Body>
                  <Modal.Footer>
                    	<Button onClick={()=>{this.setState({showConfirmationModal: false})}}>No</Button>
                    	<Button bsStyle="danger" onClick={()=>{this.performActualDeletion()}}>Yes</Button>
                  </Modal.Footer>
              </Modal>
              {this.renderPreviewModal()}
              {this.renderLinkModal()}
              {this.renderMergeModal()}
              {this.renderIncidentHistoryModal()}
			<ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
              { <Loading isShowing={this.state.isUpdatingLinkedIncidents} message={this.state.linkingMessage}/>}
              { <Loading isShowing={this.state.isMergingIncidents} message="Merging incidents..."/>}
              { <Loading isShowing={this.state.isDownloadingPDF} message="Downloading incidents..."/>}
		</div>
)
    }

    componentDidMount() {
      this.props.setDownloadPDF(this.downloadArchivePDF);
      this.props.setCountSelectedIncidents(this.countSelectedIncidents);
    }

    renderStandardIncidentsArchiveTable = () => {
        return(
            <BootstrapTable width="100%" data={ this.props.tableData ? this.props.tableData.rows : [] } hover={true} keyField="id" search={true} pagination options={this.options} trClassName={"usersRow"}>
                <TableHeaderColumn dataField='title' width="15%" dataSort dataFormat={this.renderIncidentTitle}>Incident Title</TableHeaderColumn>
                <TableHeaderColumn dataField='type' width="10%" dataSort>Type</TableHeaderColumn>
                <TableHeaderColumn dataField='facility' width="10%" dataSort>Facility</TableHeaderColumn>
                <TableHeaderColumn dataField='time' width="10%" dataSort dataFormat={this.renderDateAdded}>Time Sent</TableHeaderColumn>
                <TableHeaderColumn dataField='staff' width="10%" dataSort>Staff</TableHeaderColumn>
                <TableHeaderColumn dataField='status' width="10%" dataSort dataFormat={this.renderActions}>Status</TableHeaderColumn>
            </BootstrapTable>
        )
    }

    renderLiveNationArchiveTable = () => {
        var types = this.props.incidentTypes ? this.props.incidentTypes : [];
        var facilities = this.props.facilities ? this.props.facilities : [];
        var events = this.props.events ? this.props.events : [];

        return(
            <BootstrapTable width="100%" data={ this.props.tableData ? this.filterIncidents(this.props.tableData.rows) : [] } hover={true} keyField="id" search={true} pagination options={this.options} trClassName={"usersRow"}>
                <TableHeaderColumn dataField='title' width="15%" dataSort dataFormat={this.renderIncidentTitle}>
                    <Checkbox
                      id="select_all"
                      name="select_all"
                      inline
                      value='select_all'
                      // checked={this.state.type.includes("select_all")}
                      onChange={(e)=> this.handleSelectAll(e)}
                    >Incident Title</Checkbox>
                </TableHeaderColumn>
                <TableHeaderColumn dataField='type' width="10%" >
                          <Popup trigger={<div style={{width: 70}}>Type <Glyphicon
                                                  glyph="filter"
                                                  style={{cursor: "pointer", marginLeft: 10}}
                                                  onClick={(e)=>{
                                                  //  e.stopPropagation();
                                                  }}
                                              /></div>} position="right">
                            <FormGroup controlId="type" className="col-md-12"
                                            style={{textAlign: "center", padding: 5, borderRadius: 5}}>
                              <FormControl componentClass="select"
                                            style={{width: "100%"}}
                                            value={this.state.type ? this.state.type : ""}
                                            onChange={(e)=>{
                                              this.setState({type: e.target.value})
                                            }}>
                                            {types.length > 0
                                                  ? <option value={""}>Any</option>
                                                  : <option disabled value={""}>No Options</option> }
                                            {types.map((choice, index)=>{
                                                if(choice.is_active == 1)return <option key={index} value={choice.Value}>{choice.Value}</option>
                                              })
                                            }
                             </FormControl>
                           </FormGroup>
                          </Popup>
                </TableHeaderColumn>
                <TableHeaderColumn dataField='facility' width="10%">
                      <Popup trigger={<div style={{width: 65}}>Facility <Glyphicon
                                              glyph="filter"
                                              style={{cursor: "pointer", marginLeft: 10}}
                                              onClick={(e)=>{
                                              //  e.stopPropagation();
                                              }}
                                          /></div>} position="right center">
                          <FormGroup controlId="facility"  className="col-md-12"
                                                    style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 0}}>
                                    <FormControl componentClass="select"
                                                  style={{width: "100%"}}
                                                  value={this.state.facility ? this.state.facility : ""}
                                                  onChange={(e)=>{
                                                    this.setState({facility: e.target.value})
                                                  }}>
                                                  {facilities.length > 0
                                                        ? <option value={""}>Any</option>
                                                        : <option disabled value={""}>No Options</option> }
                                                  {facilities.map((choice, index)=>{
                                                      if(choice.is_active == 1)return <option key={index} value={choice.facility_name}>{choice.facility_name}</option>
                                                    })
                                                  }
                                    </FormControl>
                          </FormGroup>
                      </Popup>
                </TableHeaderColumn>
                <TableHeaderColumn dataField='event' width="10%">
                        <Popup trigger={<div style={{width: 70}}>Events <Glyphicon
                                                glyph="filter"
                                                style={{cursor: "pointer", marginLeft: 10}}
                                                onClick={(e)=>{
                                                //  e.stopPropagation();
                                                }}
                                            /></div>} position="right center">
                              <FormGroup controlId="events"  className="col-md-12"
                                                        style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 0}}>
                                        <FormControl componentClass="select"
                                                      style={{width: "100%"}}
                                                      value={this.state.event ? this.state.event : ""}
                                                      onChange={(e)=>{
                                                        this.setState({event: e.target.value})
                                                      }}>
                                                      {events.length > 0
                                                            ? <option value={""}>Any</option>
                                                            : <option disabled value={""}>No Options</option> }
                                                      {events.map((choice, index)=>{
                                                          if(choice.is_active == 1)return <option key={index} value={choice.event_name}>{choice.event_name}</option>
                                                        })
                                                      }
                                        </FormControl>
                              </FormGroup>
                        </Popup>
                </TableHeaderColumn>
                <TableHeaderColumn dataField='time' width="10%" dataSort dataFormat={this.renderDateAdded}>Date</TableHeaderColumn>
                <TableHeaderColumn dataField='status' width="10%" dataSort dataFormat={this.renderActions}>Status</TableHeaderColumn>
            </BootstrapTable>
        )
    }

    renderIncidentTitle = (cell, row, rowIndex, formatExtraData) => {
        if (this.state.itemToEditIndex != formatExtraData){
            return(
                <div>
                    <Form>
                        <FormGroup>
                            <Checkbox id="active"
                                checked = {this.state.selectedIncidents.includes(row.id)}
                                onChange={()=> this.handleCheckBoxTick(row)}
                                onClick={()=> this.deleteItemClicked = true}>{row.title}</Checkbox>
                        </FormGroup>
                    </Form>
                </div>

            )
        }
        else {
            return (
                <div className="form-inline">
                    <input type="text"
                        className="form-control edit-report-field" style={{textAlign: "center"}}
                        value={this.state[row.id] != null ? this.state[row.id] : row.name}
                        onChange={(e)=>{
                            this.setState({ [row.id]: e.target.value });
                        }}/>
                    <button className="btn btn-primary" onClick={()=>this.onSaveButtonHandler(row.id)}>Save</button>
                </div>
            )
        }
    }

    renderLinkIncidentTitle(cell, row, rowIndex, formatExtraData) {

            return(
                <div>
                    <Form>
                        <FormGroup>

                            <Checkbox id="active"
                                defaultChecked={false}
                                onChange={()=> this.handleCheckBoxTick(row)}
                                onClick={()=> this.deleteItemClicked = true}>  NANI?!</Checkbox>
                        </FormGroup>
                    </Form>
                </div>
            )
    }

    renderLinkIncidentAction(cell, row, formatExtraData) {
      var linkedFiles = formatExtraData.allLinkedFiles;
      var fileExists = _.find(linkedFiles, (linkedFile)=>{
        return linkedFile.id === row.id
      })

      if(fileExists) {
        return (<div>
                  <Button onClick={()=>{ this.linkToSelectedIncidents(row)}}>Unlink</Button>
                </div>);
      } else {
        return (<div>
                  <Button onClick={()=>{ this.linkToSelectedIncidents(row)}}>Link</Button>
                </div>);
      }

    }

    renderLinkIncidentDate(cell, row, rowIndex, formatExtraData) {
        return (<div>
                  {moment(row.time).format("MM-DD-YYYY")}
                </div>)
    }

    renderDateAdded = (cell, row, rowIndex, formatExtraData) => {

        Date.prototype.formattedTime = function(){
            var h = this.getHours();
            var m = this.getMinutes();
            var ampm = h<12 && m <= 59 ? "AM" : "PM";
            h = h>12 ? h-12 : (h == 0 ? 12 : h);
            m = m<10 ? ('0'+m) : m;

            return h+':'+m+' '+ampm;
        }

        var archive_date = new Date(cell);
        var date = (archive_date.getMonth()+1) + "/" + archive_date.getDate() + "/" + archive_date.getFullYear();
        var time = archive_date.formattedTime();
        if(archive_date === " Invalid Date") {
          var incident = _.find(this.props.incidents, (incident)=>{ return incident.id === row.id })
          archive_date = incident.date_added;

        }
        return (
            //<h5> {date} {`\n`} @ {time} </h5>
            <h5> {moment(archive_date).format("MM-DD-YYYY")}</h5>
        )
    }

    renderActions = (cell, row, rowIndex, formatExtraData) => {
        var classStyle = "";
        switch (row.status){
            case "Completed":
                classStyle = "status-completed";
                break;
            case "Needs Attention":
                classStyle = "status-failed";
                break;
            case "In Progress":
                classStyle = "status-in-progress";
                break;
            default:
                break;
        }
        return(
            <div className="action-items">
                <div>
                    <h5 className={classStyle}>{row.status}</h5>
                </div>
            </div>
        )
    }

    renderHistoryDate (cell, row, rowIndex, formatExtraData) {
      return moment.unix(row.date).format("MM/DD/YYYY");
    }

    renderHistoryTime (cell, row, rowIndex, formatExtraData) {
      return moment.unix(row.date).format("h:mm A");
    }

    renderPreviewModal() {

        if (this.state.selectedItem != null){
            var other_form_data =  [];
            try{
               other_form_data = this.state.selectedItem.other_form_data != null ? JSON.parse(this.state.selectedItem.other_form_data) : [];
            }
            catch(e){

            }
            return (
                <Modal show={this.state.showInfoModal}>
                    <Modal.Header>
                        <b style={{fontSize: 20}}>

                        <OverlayTrigger
                            placement="top"
                            delay={200}
                            overlay={
                                    <Tooltip id="overlay-example"> Close </Tooltip>
                            }>
                            <Glyphicon
                                glyph="remove"
                                className="pull-right"
                                style={{cursor: "pointer", marginLeft: 10}}
                                onClick={()=>{
                                    this.setState({showInfoModal: false});
                                }}
                            />
                        </OverlayTrigger>

                        <OverlayTrigger
                            placement="top"
                            delay={200}
                            overlay={<Tooltip id="overlay-example">
                                        Download this item
                                    </Tooltip>}>
                        <Glyphicon glyph="download-alt"
                            className={"pull-right"}
                            onClick={()=>{
                                    this.downloadArchivePDF();
                                    }}
                            style={{ cursor: "pointer", marginLeft: 10}}/>
                        </OverlayTrigger>

                        <OverlayTrigger
                            placement="top"
                            delay={200}
                            overlay={
                                    <Tooltip id="overlay-example">
                                        Edit this item
                                    </Tooltip>
                                }>
                        <Glyphicon glyph="pencil"
                            className={"pull-right"}
                            onClick={()=>{
                                    this.editArchiveItem();
                                    this.setState({showInfoModal: false});
                                }}
                            style={{ cursor: "pointer", marginLeft: 10}}/>
                        </OverlayTrigger>

                        </b>
                    </Modal.Header>
                    <Modal.Body>
                        <div id="canvasWindow">
                            { this.renderFormSection() }
                            { this.renderEmailSection() }
                        </div>
                    </Modal.Body>
                </Modal>
            )
        }
    }

    renderLinkModal() {


        return  (<Modal style={{marginTop: "10%"}}
                        show={this.props.showLinkIncidentsModal}
                        onExit={()=>{}}>
                        <Modal.Header>
                          <b style={{fontSize: 20}}>Link Files</b>
                        </Modal.Header>
                        <Modal.Body>
                          <BootstrapTable width="100%" data={ this.props.tableData ? this.filterIncidents(this.props.tableData.rows) : [] } hover={true} keyField="id" search={true} pagination options={this.linkIncidentOptions} trClassName={"usersRow"}>
                              <TableHeaderColumn dataField='time' width="10%" dataSort dataFormat={this.renderLinkIncidentDate}>Date</TableHeaderColumn>
                              <TableHeaderColumn dataField='title' width="10%" dataSort>Title</TableHeaderColumn>
                              <TableHeaderColumn dataField='facility' width="10%" dataSort>Venue</TableHeaderColumn>
                              <TableHeaderColumn dataField='event' width="10%" dataSort>Event</TableHeaderColumn>
                              <TableHeaderColumn dataField='location' width="15%">Location</TableHeaderColumn>
                              <TableHeaderColumn width="10%" dataFormat={this.renderLinkIncidentAction} formatExtraData={{allLinkedFiles: this.state.allLinkedFiles}}>Action</TableHeaderColumn>
                          </BootstrapTable>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button bsStyle="danger" onClick={()=>{this.props.setShowLinkIncidentsModal(false)}}>Close</Button>
                        </Modal.Footer>
               </Modal>
        )

    }

    renderIncidentHistoryModal() {

      var testData = [{user: "Joshua", date: new Date("06-20-2017 10:30 AM"), action: "Submitted"},
                      {user: "Joshua", date: new Date("07-25-2014 2:30 PM"), action: "Edited"},
                      {user: "Joshua", date: new Date("04-30-2015 5:30 AM"), action: "Merged"},
                      {user: "Joshua", date: new Date("08-11-2014 9:00 AM"), action: "Merged"}];

      var selectedItem = this.state.selectedItem;
      var tableData = testData;
      var other_form_data = selectedItem && UtilsService.sharedInstance.tryParseJSON(selectedItem.other_form_data) ? JSON.parse(selectedItem.other_form_data) : {};
      var indivudals_data = selectedItem && UtilsService.sharedInstance.tryParseJSON(selectedItem.individuals_data) ? JSON.parse(selectedItem.individuals_data)[0] : null;
      var historyName = indivudals_data ? indivudals_data.name : "No Name";

      return (
          <Modal show={this.state.showIncidentHistoryModal} style={{marginTop: "10%"}}>
              <Modal.Header>
                  <b style={{fontSize: 20}}>
                  {historyName}'s History
                  <OverlayTrigger
                      placement="top"
                      delay={200}
                      overlay={
                              <Tooltip id="overlay-example"> Close </Tooltip>
                      }>
                      <Glyphicon
                          glyph="remove"
                          className="pull-right"
                          style={{cursor: "pointer", marginLeft: 10}}
                          onClick={()=>{
                              this.setState({showIncidentHistoryModal: false});
                          }}/>
                  </OverlayTrigger>
                  </b>
              </Modal.Header>
              <Modal.Body>
                <BootstrapTable width="100%" data={ this.state.historyData ? this.state.historyData : [] } hover={true} keyField="id" search={true} options={this.incidentHistoryOptions} pagination trClassName={"usersRow"}>
                    <TableHeaderColumn dataField='user' width="15%">User</TableHeaderColumn>
                    <TableHeaderColumn dataField='date' dataFormat={this.renderHistoryDate}  width="10%">Date</TableHeaderColumn>
                    <TableHeaderColumn dataField='date' width="10%" dataFormat={this.renderHistoryTime}>Time</TableHeaderColumn>
                    <TableHeaderColumn dataField='action' width="10%" >Action</TableHeaderColumn>
                </BootstrapTable>
              </Modal.Body>
          </Modal>
      );
    }

    renderFormSection(item) {
        let incident = item ? item : this.state.selectedItem;
        var json_data = [];
        try{
            json_data = JSON.parse(incident.individuals_data);
        }
        catch(e){
            //do nothing
        }

        let attachments  = [];
        try{
            attachments = incident.attachments_data ? JSON.parse(incident.attachments_data) : null;
        }
        catch(e){
            attachments = [];
        }

        attachments = Array.isArray(attachments) ? attachments : [];

        let incidentType = null;
        try{
            incidentType = incident.incident_type != null
                            ? incident.incident_type
                            : incident.other_form_data != null && incident.other_form_data !== ""
                              ? JSON.parse(incident.other_form_data).incident_type
                                  ? this.props.stringArrayToString(JSON.parse(incident.other_form_data).incident_type)
                                  : "No Incident Type"
                              : "No Incident Type";
        }
        catch(e){
            incidentType = "No Incident Type";
        }

        //check furthere if employee form
        if(incidentType == "No Incident Type" || incidentType == null){
              try{
                  //check if employee form
                  let otherFormData = JSON.parse(incident.other_form_data);
                  let employeeForm = otherFormData.employee_form == true || otherFormData.employee_form == 1 ? "Employee" : "";
                  incidentType = employeeForm;
              }
              catch(e){
                  incidentType = "No Incident Type";
              }
          }

        let incidentLocation = null;
        try{
            incidentLocation = incident.location_name != null
                                  ? incident.location_name
                                  : this.props.getNameForRecno(incident.facility_location_id, "Facility Location");
        }
        catch(e){
            incidentLocation = "Facility Location";
        }

        let incidentDescription = null;
        try{
            incidentDescription = incident.location_description != null
                                      ? incident.location_description
                                      : incident.other_form_data != null && incident.other_form_data !== ""
                                            ? JSON.parse(incident.other_form_data).location_desc
                                            : "No Location Description";
        }
        catch(e){
            incidentDescription = "No Location Description";
        }

        let linked_files = null;
        try{
            linked_files = incident.other_form_data
                                        ? JSON.parse(incident.other_form_data).linked_files != null && JSON.parse(incident.other_form_data).linked_files.length > 0
                                        ? JSON.parse(incident.other_form_data).linked_files
                                        : []
                                    : [];
        }
        catch(e){
            linked_files = [];
        }

        var linked_files_ids = [];
        linked_files = linked_files ? linked_files : [];
        linked_files.map((file) => {
          if(file){
            const {title,id} = file;


            if(title){
              linked_files_ids.push({
                id,
                name:title
              })
            }else{
              const invidivuals_data = UtilsService.sharedInstance.tryParseJSON(file.individuals_data) ? JSON.parse(file.individuals_data) : [];
              const individual = invidivuals_data && invidivuals_data.length ? invidivuals_data[0] : false;
              const name = individual && individual.name  ? individual.name : '';

              linked_files_ids.push({
                id,
                name
              });
            }
          }
        });

        let invidualName = "";
        try{
            invidualName = json_data[0].name;
        }
        catch(e){
            invidualName = "";
            json_data = [];
        }

        json_data = Array.isArray(json_data) ? json_data : [];

        return(
            <div className="incident-section" id="canvasWindow">
                <h3 className="orange-title">{invidualName}</h3>
                <Row><Col md={10}><h3 className="sub-title">Incident Information</h3></Col> <Col md={2}><Button className="pull-right" onClick={()=>{this.setState({showIncidentHistoryModal: true})}}>History</Button></Col>  </Row>
                <hr className="line"/>

                <div className="left-side-content">
                    <h5 className="info-type">Type of Incident: <span className="info-data">{incidentType}</span></h5>
                    <h5 className="info-type">Facility: <span className="info-data">{incident && incident.facility_name ? incident.facility_name : "None"}</span></h5>
                    <h5 className="info-type">Location: <span className="info-data">{incidentLocation ? incidentLocation : "None"}</span></h5>
                    <h5 className="info-type">Detailed Location Description:</h5>
                    <p className="paragraph info-data">{incidentDescription ? incidentDescription : "None"}</p>

                    <h5 className="info-type">Linked Files:</h5>
                    <div className="attachments-div">
                        {
                          linked_files_ids.map((name, i)=>{
                              return <h5 key={name.name +"_"+i} style={{cursor: "pointer"}}
                                        onClick={()=>{
                                            var incidents = this.props.incidents;
                                            var incidentToOpen = _.find(incidents, (incident)=>{
                                              return incident.id === name.id
                                            });

                                            this.setState({
                                              selectedItem: incidentToOpen
                                            })
                                          }}><span className="info-data">{name.name}</span></h5>
                          })
                        }
                    </div>
                </div>

                <div className="right-side-content">
                    <h5 className="info-type">Dispatch No: <span className="info-data">{incident && incident.dispatch_no ? incident.dispatch_no : "None"}</span></h5>
                    {
                        json_data.map((individual, i)=>{
                            return(
                                <div className="individual-box" key={individual.name + "_" + i}>
                                    <h5 className="info-type">Individual Name: <span className="info-data">{individual.name}</span></h5>
                                    <h5 className="info-type">Individual Role: <span className="info-data">{individual.type ? individual.type : "Guest" }</span></h5>
                                    <h5 className="info-type">Narrative:</h5>
                                    <p className="paragraph info-data">{individual.narrative ? individual.narrative : individual.how_incident ? individual.how_incident : "None"}</p>
                                </div>
                            )
                        })
                    }

                    <h5 className="info-type">Attachments:</h5>
                    <div className="attachments-div">
                    {
                        attachments
                        ? attachments.map((file, index) => {
                            return (
                                <img key={file.name} className="attachment-image" src={file.path} width={100} height={70}/>
                            )
                        })
                        : "No Attachments"
                    }
                    </div>
                </div>
            </div>
        )
    }

    renderEmailSection(item) {
        let incident = item ? item : this.state.selectedItem;
        let json_data = [];
        try{
            json_data = JSON.parse(incident.external_agency_data);
        }
        catch(e){
            json_data = [];
        }

        json_data = Array.isArray(json_data) ? json_data : [];


        if(incident && incident.incident_form_type === "live_nation") {

        } else {
          return(
              <div className="incident-section">
                  <div className="left-side-content">
                      <h3 className="sub-title section-title-with-toggle">External Agency</h3>
                      <hr className="line"/>

                      {
                          json_data.map((department)=>{
                              switch(department.type){
                                  case 'fire_department':
                                      var time_value = this.renderTime(department.time_dispatched);
                                      return (
                                          <h5 className="info-type" key={department.type}>Fire Department: <br />Time Dispatched: <span className="info-data">{time_value}</span></h5>
                                      )
                                  case 'police':
                                      var time_value = this.renderTime(department.time_arrived);
                                      return (
                                          <h5 className="info-type" key={department.type}>Police: <br />Time Arrived: <span className="info-data">{time_value}</span></h5>
                                      )
                                  case 'ambulance':
                                      var time_value = this.renderTime(department.time_cleared);
                                      return (
                                          <h5 className="info-type" key={department.type}>Ambulance: <br />Time Cleared: <span className="info-data">{time_value}</span></h5>
                                      )
                                  default:
                                      return null;
                              }
                          })
                      }

                  </div>

                  <div className="right-side-content">
                      <h3 className="sub-title section-title-with-toggle">Email Incident</h3>
                      <hr className="line"/>

                      <h5 className="info-type">Email Address: <br/><span className="info-data">{incident && incident.auto_email}</span></h5>
                  </div>
              </div>
          )
        }

    }

    renderTime(time) {

        var hours_array = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        var timeStr = "";
        var hours = Math.trunc(time / 3600);
        var minutes = Math.trunc((time - (3600 * hours))/60);
        var seconds = (time - (hours * 3600) - (minutes * 60));

        var minutesStr = minutes <10 ? ("0"+minutes) : (minutes+"");
        var day_string = hours < 11? "AM" : "PM";
        timeStr = hours_array[hours] + ":"+minutesStr + " " + day_string;

        return timeStr;
    }

    renderFilters() {

      var types = this.props.incidentTypes ? this.props.incidentTypes : [];
      var facilities = this.props.facilities ? this.props.facilities : [];
      var events = this.props.events ? this.props.events : [];

      return (<Row style={{paddingLeft: 15}}>
                <Col>
                  <Row >
                  <FormGroup controlId="dateStart"  className="col-md-2"
                                        style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                                        <ControlLabel className="login_label">Select Start Date</ControlLabel>
                                        <Datetime
                                          timeFormat={false}
                                          value={this.state.dateStart}
                                          onChange={(e)=>{
                                                this.props.fetchIncidents(e, this.state.dateEnd);
                                                this.setState({dateStart: e})
                                            }
                                          }/>
                                        </FormGroup>

                <FormGroup controlId="dateEnd"  className="col-md-2"
                                        style={{textAlign: "center", padding: 5, borderRadius: 5}}>
                                        <ControlLabel className="login_label">Select End Date</ControlLabel>
                                        <Datetime
                                          timeFormat={false}
                                          value={this.state.dateEnd}
                                          onChange={(e)=>{
                                            this.props.fetchIncidents(this.state.dateStart, e)
                                            this.setState({dateEnd: e});
                                            ;
                                          }}/>
                                        </FormGroup>
                  </Row>
                  {
                    // <Row>
                    // <FormGroup controlId="type"  className="col-md-3"
                    //                           style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                    //           <ControlLabel className="login_label">Type</ControlLabel>
                    //           <FormControl componentClass="select"
                    //                         style={{width: "100%"}}
                    //                         value={this.state.type ? this.state.type : ""}
                    //                         onChange={(e)=>{
                    //                           console.log("e.target.value: ",e.target.value);
                    //                           this.setState({type: e.target.value})
                    //                         }}>
                    //                         {types.length > 0
                    //                               ? <option value={""}>Any</option>
                    //                               : <option disabled value={""}>No Options</option> }
                    //                         {types.map((choice, index)=>{
                    //                             return <option key={index} value={choice.Value}>{choice.Value}</option>
                    //                           })
                    //                         }
                    //           </FormControl>
                    // </FormGroup>
                    //
                    // <FormGroup controlId="facility"  className="col-md-3"
                    //                           style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                    //           <ControlLabel className="login_label">Facility</ControlLabel>
                    //           <FormControl componentClass="select"
                    //                         style={{width: "100%"}}
                    //                         value={this.state.facility ? this.state.facility : ""}
                    //                         onChange={(e)=>{
                    //                           console.log("e.target.value: ",e.target.value);
                    //                           this.setState({facility: e.target.value})
                    //                         }}>
                    //                         {facilities.length > 0
                    //                               ? <option value={""}>Any</option>
                    //                               : <option disabled value={""}>No Options</option> }
                    //                         {facilities.map((choice, index)=>{
                    //                             return <option key={index} value={choice.facility_name}>{choice.facility_name}</option>
                    //                           })
                    //                         }
                    //           </FormControl>
                    // </FormGroup>
                    //
                    // <FormGroup controlId="events"  className="col-md-3"
                    //                           style={{textAlign: "center", padding: 5, borderRadius: 5, marginLeft: 10}}>
                    //           <ControlLabel className="login_label">Events</ControlLabel>
                    //           <FormControl componentClass="select"
                    //                         style={{width: "100%"}}
                    //                         value={this.state.event ? this.state.event : ""}
                    //                         onChange={(e)=>{
                    //                           console.log("e.target.value: ",e.target.value);
                    //                           this.setState({event: e.target.value})
                    //                         }}>
                    //                         {events.length > 0
                    //                               ? <option value={""}>Any</option>
                    //                               : <option disabled value={""}>No Options</option> }
                    //                         {events.map((choice, index)=>{
                    //                             return <option key={index} value={choice.event_name}>{choice.event_name}</option>
                    //                           })
                    //                         }
                    //           </FormControl>
                    // </FormGroup>
                    // </Row>
                  }
                </Col>
              </Row>)
    }

    downloadArchivePDF(isList) {
        if(this.props.incidentType == "live_nation"){
          if(isList == null || !isList) {
            var selectedItem = this.state.selectedItem;
            let other_form_data = UtilsService.sharedInstance.tryParseJSON(selectedItem.other_form_data) ? JSON.parse(selectedItem.other_form_data) : {};
            if(other_form_data) {
              if(other_form_data.employee_form) {
                pdfMake.createPdf(this.props.prepLiveNationPDFDocDefinitionEmployee(this.state.selectedItem)).open()
              } else {
                pdfMake.createPdf(this.props.prepLiveNationPDFDocDefinition(this.state.selectedItem)).open();
              }
            }

          } else {
            this.setState({isDownloadingPDF: true});

            var zip = new JSZip();
            var pdfList = this.state.selectedIncidents;
            var itemsToWait = pdfList.length;

            if(itemsToWait <= 0) {
              ToastStore.error("You have not selected any Incidents!");
            }
            pdfList.map((item, i)=>{
              var pdfDocGenerator = null;

              var rawIncident = _.find(this.props.incidents, (incident)=>{
                return incident.id === item
              })

              let other_form_data = UtilsService.sharedInstance.tryParseJSON(rawIncident.other_form_data) ? JSON.parse(rawIncident.other_form_data) : {};

              if(other_form_data.employee_form) {
                pdfDocGenerator = pdfMake.createPdf(this.props.prepLiveNationPDFDocDefinitionEmployee(rawIncident))
              } else {
                pdfDocGenerator = pdfMake.createPdf(this.props.prepLiveNationPDFDocDefinition(rawIncident))
              }

              // var pdfDocGenerator = pdfMake.createPdf(this.props.prepLiveNationPDFDocDefinition(rawIncident))

              pdfDocGenerator.getBlob((blob)=>{
                itemsToWait--;
                var name = UtilsService.sharedInstance.tryParseJSON(rawIncident.individuals_data) ? JSON.parse(rawIncident.individuals_data)[0].name : rawIncident.id;
                zip.file(name+".pdf", blob);
                if(itemsToWait <= 0) {
                  zip.generateAsync({type : "blob"})
                  .then((blob)=>{
                     saveAs(blob, "IncidentReportsPDF.zip");
                     this.setState({isDownloadingPDF: false});
                  });
                }
              });
            })
          }
        }
        else{
          //================OLD PDF GENERATION STANDARD INCIDENTS==============//
          var componentToConvert = document.getElementById('canvasWindow');//$("#canvasWindow");
          html2canvas(componentToConvert)
              .then((canvas)=>{
                  const imgData = canvas.toDataURL('image/png');
                  const pdf = new jsPDF();
                  pdf.addImage(imgData, 'JPEG', 0, 0);
                  pdf.save("Incident.pdf");
              })
              .catch((e)=>{
                  console.log("canvas error: ", e);
              })
          //================OLD PDF END========================//
        }
      }

    setItemToEdit(index) {
  		this.setState({
  			itemToEditIndex: index == this.state.itemToEditIndex ? null : index
  		})
    }

    onDeleteItem() {
		this.setState({
            showConfirmationModal: true,
            itemToEditIndex: null
		});
    }

    onLinkIncidents(){

      var rawIncident = null;//Incident to link to selected
      var incidentsToUpdate = [];

      let params = {
          "ids" : this.state.selectedIncidents
      }

      this.setState({
            isUpdatingLinkedIncidents: true,
            linkingMessage: "Linking incidents..."
      });

      IncidentService.sharedInstance.link(params)
      .then((response)=>{
          this.setState({
              isUpdatingLinkedIncidents: false
          });

          if (response){
              ToastStore.success("Successfully linked incidents!");
              //this.setState({selectedIncidents: []});
              this.props.fetchIncidents();

          }
          else {
              ToastStore.error("Error while trying to delete incident!");
          }


      })


      //Call aPI here. Ena does magic with id's kuno. pass state.selectedIncidents
      /*if (this.state.selectedIncidents){
        // Find the current incident's raw incident value:
        var rawIncidents = [];//this.props.incidents.slice();

        //get full incident object from id
        this.state.selectedIncidents.map((id)=>{
          var raw = _.find(this.props.incidents, (incident)=>{
            return incident.id === id
          });

          if(raw) {
            rawIncidents.push(raw);
          }
        });

        rawIncidents.map((rawIncident) => {
          var other_form_data = [];
          var newLinkedFiles = [];

          other_form_data = rawIncident && rawIncident.other_form_data ? JSON.parse(rawIncident.other_form_data) : null;

          if(other_form_data) {
            newLinkedFiles = other_form_data.linked_files.slice();

            //Add every incident in selectedIncidents to this selected incident's linked_files
            rawIncidents.map((raw)=>{
                  var exists = null;

                  exists = _.find(newLinkedFiles, (linkedFile)=>{
                    return linkedFile.id === raw.id || linkedFile.id === rawIncident.id
                  });

                  if(!exists) {
                    newLinkedFiles.push(raw);
                  }
            });

            other_form_data.linked_files = newLinkedFiles;

            incidentsToUpdate.push({id: rawIncident.id, other_form_data: other_form_data});

            console.log('linking ', rawIncident);

          }


          //this.linkToSelectedIncidents(rawIncident);
        });

        console.log("incidentsToUpdate: ", incidentsToUpdate);

      }*/
    }

    editArchiveItem() {
        this.props.editMode(this.state.selectedItem);
    }

    fetchIncidentInfo(incident_id) {

        if (this.deleteItemClicked == true){
            return;
        }

        var matchingItem = null;
        this.props.incidents.map((item)=>{
            if (item.id == incident_id && matchingItem == null){
                matchingItem = item;
            }
        });
        return matchingItem;
        //this.setState({selectedItem: matchingItem, showInfoModal: true});
    }

    handleSelectAll(e){

      this.deleteItemClicked = true;
      var new_array = [];

      // Perform loop and add all items to the selected incidents before updating the view.
      if (this.state.selectAll == false){
        this.props.tableData.rows.map((row) => {
          var alreadyInDelete = this.state.selectedIncidents.includes(row.id);

          if (alreadyInDelete){
              new_array = this.state.selectedIncidents.filter(function(value){
                  return value != row.id
              });
          }
          else {
              new_array = this.state.selectedIncidents;
              new_array.push(row.id);
          }
        })
      }

      this.setState({selectAll: this.state.selectAll === false ? true : false, selectedIncidents: new_array});
    }

    handleCheckBoxTick(row) {
        this.deleteItemClicked = true;
        // const active_status = row.active == 1? 0 : 1;
        var alreadyInDelete = this.state.selectedIncidents.includes(row.id);
        var new_array = [];

        if (alreadyInDelete){
            new_array = this.state.selectedIncidents.filter(function(value){
                return value != row.id
            });
        }
        else {
            new_array = this.state.selectedIncidents;
            new_array.push(row.id);
        }

        this.setState({selectedIncidents: new_array});
        this.getAllLinkedFiles();
        // Use this for the meantime:
        setTimeout(function() { //Start the timer
            this.deleteItemClicked = false;
        }.bind(this), 1000)
    }

    performActualDeletion() {
        this.state.selectedIncidents.map((item) => {
            let params = {
                "license": this.state.license,
                "token": this.state.token,
                "auth_username": this.state.auth_username,
                "id" : item
            }

            IncidentService.sharedInstance.delete(params)
            .then((response)=>{
                if (response){
                    ToastStore.success("Successfully deleted incident!");
                    this.setState({selectedIncidents: []});
                    this.props.fetchIncidents();
                }
                else {
                    ToastStore.error("Error while trying to delete incident!");
                }


            })
        })

        this.setState({showConfirmationModal: false});
    }

    pdfRenderWitnesses() {

    }

    //Old. We link via back end now. May 10, 2019 - Tere
    linkToSelectedIncidents(incident) {
      var selectedIncidents = this.state.selectedIncidents;
      var rawSelectedIncident = null;
      var rawIncidents = this.props.incidents.slice();
      var rawIncident = incident;//Incident to link to selected
      var other_form_data = null;
      // rawIncident = _.find(rawIncidents, (raw)=>{
      //   return raw.id === incident.id
      // });
      if(rawIncident != null) {
        if(selectedIncidents && selectedIncidents.length > 0) {
          selectedIncidents.map((selected)=>{

            rawSelectedIncident = _.find(rawIncidents, (raw)=>{
              return raw.id === selected
            });
            if(rawSelectedIncident != null && rawSelectedIncident.id != incident.id) {
              if(rawSelectedIncident.other_form_data) {//Check if LiveNation

                other_form_data =  UtilsService.sharedInstance.tryParseJSON(rawSelectedIncident.other_form_data) ? JSON.parse(rawSelectedIncident.other_form_data) : [];


                if(other_form_data.linked_files == null) {
                  other_form_data["linked_files"] = [];
                }

                var hasRawIncidentAlready = _.find(other_form_data.linked_files, (linked_file)=>{
                  return linked_file != null && linked_file.id == rawIncident.id
                });
                if(hasRawIncidentAlready == null) {
                  other_form_data.linked_files.push(rawIncident);
                  rawSelectedIncident.other_form_data = JSON.stringify(other_form_data);

                  this.submitUpdatedIncident(rawSelectedIncident, "linked");
                } else {
                  var index = -1;
                  other_form_data.linked_files.map((file, i)=>{
                    if(file != null && file.id === rawIncident.id) {
                      index = i;
                    }
                  });
                  other_form_data.linked_files.splice(other_form_data.linked_files.indexOf(hasRawIncidentAlready), 1);
                  rawSelectedIncident.other_form_data = JSON.stringify(other_form_data);
                  this.submitUpdatedIncident(rawSelectedIncident, "unlinked");
                }
              }

            }

          });
        } else {
          ToastStore.error( "You have no selected Incidents to link to!");
        }
      } else {
        console.log("RawIncident not found for: ", incident);
      }


    }

    unlinkFromSelectedIncidents(incident) {

    }

    submitUpdatedIncident(incident, msg) {

        var other_form_data = incident.other_form_data;

        var params = incident;
        params["files"] = incident.attachments_data ? incident.attachments_data.slice() : [];
        params = _.omit(params, "User_Type", "attachments_data", "auto_email", "auto_email_id", "branch_name", "dispatch_no",
                                "event_name", "external_agency_data", "facility_name", "first_name", "last_name", "location_name", "status");
        params["auth_username"] = this.state.auth_username;
        params["license"] = this.state.license;
        params["token"] = this.state.token;

        this.setState({
            isUpdatingLinkedIncidents: true,
            linkingMessage: msg == "linked" ? "Linking..." : "Unlinking..."
        });


        IncidentService.sharedInstance.editCustomIncident(params)
        .then((response)=>{
            if(msg !== "linked") {
              ToastStore.success( "Incident successfully "+msg+"!");
            }

            this.props.fetchIncidents();
            this.getAllLinkedFiles();

            this.setState({
                isUpdatingLinkedIncidents: false
            });
        })
        .catch((err)=>{
            console.log("fail, error: ", err);
            ToastStore.error( "Incident edit failed.");
            this.setState({
                isUpdatingLinkedIncidents: false
            });
        })
    }

    getAllLinkedFiles() {
      var selectedIncidents = this.state.selectedIncidents ? this.state.selectedIncidents.slice() : [];
      var allLinkedFiles = [];
      var other_form_data = [];
      var linked_files = [];

      var rawIncidents = this.props.incidents.slice();
      var rawIncident = null;

      selectedIncidents.map((selectedIncident)=>{

        rawIncident = _.find(rawIncidents, (raw)=>{
          return raw.id === selectedIncident
        });

         try{
            other_form_data = UtilsService.sharedInstance.tryParseJSON(rawIncident.other_form_data) ? JSON.parse(rawIncident.other_form_data) : {};
            linked_files = other_form_data ? other_form_data.linked_files : [];
        }
        catch(e){

        }

        linked_files = Array.isArray(linked_files) ? linked_files : [];

        linked_files.map((linked_file)=>{
          var fileExists = _.find(allLinkedFiles, (allLinkedFile)=>{
            return linked_file != null && allLinkedFile.id === linked_file.id
          });

          if(fileExists == null && linked_file != null) {
            allLinkedFiles.push(linked_file);
          }
        })
      })

      this.setState({
        allLinkedFiles: allLinkedFiles
      })
      return allLinkedFiles;
    }

    filterIncidents() {

      var type = this.state.type;
      var facility = this.state.facility;
      var event = this.state.event;
      var isEqualType = (incidentType) => {
        const lowerIncidentType = incidentType ? (incidentType).toLowerCase().replace(/ /g,'_') : '';
        const lowerType = type ? (type).toLowerCase().replace(/ /g,'_') : '';

        return lowerIncidentType.indexOf(lowerType) >= 0 ? true : false;
      }
      var isEqualFacility = (incidentFacility) => { return facility === incidentFacility || facility == null || facility === ""}
      var isEqualEvent = (incidentEvent) => { return event === incidentEvent || event == null || event === ""}

      var isValidDate = (date) => {return (new Date(date) >= new Date(this.state.dateStart) && new Date(date) <= new Date(this.state.dateEnd))}

      if(this.props.tableData && this.props.tableData.rows) {
        return _.filter(this.props.tableData.rows, (row) => {
          return isEqualType(row.type) && isEqualFacility(row.facility) && isEqualEvent(row.event);
          // return isEqualBranch(this.props.getRecnoForName(schedule.branch, "Branch"))
          //           && isEqualClient(this.props.getRecnoForName(schedule.client, "Client"))
          //           && isEqualFacility(this.props.getRecnoForName(schedule.facility, "Facility"));
                    //&& isValidDate(schedule.date)
        });
      } else {
        return [];
      }
    }

    renderMergeModal() {
      var selectedIncidents = this.state.selectedIncidents;
      var tooMany = (selectedIncidents.length > 2);

      //if(selectedIncidents.length > 0) {

        return (<Modal style={{marginTop: "5%"}}
                  dialogClassName={"mergeModal"}
                  show={this.props.showMergeModal}
                  onExit={()=>{}}>
                <Modal.Header>
                    <b style={{fontSize: 20}}>Archive Merge</b>
                </Modal.Header>
                <Modal.Body>
                    <div style={{textAlign: 'left'}}>
                    {tooMany ?
                              <Row style={{color: "red", textAlign: "center"}}>
                                More than 2 incidents selected!
                              </Row>
                          : null}
                    <Row>
                      <Col md={7}>
                        <Row>
                          <Col md={9}>
                            <div id="canvasWindow">
                                { (selectedIncidents && selectedIncidents.length > 0)
                                    ? this.renderFormSection(this.fetchIncidentInfo(selectedIncidents[0]))
                                    : <Row style={{marginTop: "20%", textAlign: "center"}}>No Form Selected</Row>}
                                { (selectedIncidents && selectedIncidents.length > 0)
                                    ? this.renderEmailSection(this.fetchIncidentInfo(selectedIncidents[0]))
                                    : null}
                            </div>
                          </Col>
                          <Col md={3} >
                            <Glyphicon
                                glyph="arrow-right"
                                style={{marginTop: "60%", marginLeft: "40%", fontSize: 30}}
                            />
                          </Col>
                        </Row>

                      </Col>
                      <Col md={5}>
                        <div id="canvasWindow">
                        { (selectedIncidents && selectedIncidents.length > 1)
                            ? this.renderFormSection(this.fetchIncidentInfo(selectedIncidents[1]))
                            : <Row style={{marginTop: "20%", textAlign: "center"}}>No Second Form Selected</Row>}
                        { (selectedIncidents && selectedIncidents.length > 1)
                            ? this.renderEmailSection(this.fetchIncidentInfo(selectedIncidents[1]))
                            : null}
                        </div>
                      </Col>
                    </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{this.props.setShowMergeModal(false)}}>Cancel</Button>
                    <Button disabled={!(selectedIncidents != null && selectedIncidents.length == 2) || tooMany} bsStyle="danger" onClick={()=>{this.mergeItems(this.fetchIncidentInfo(selectedIncidents[0]), this.fetchIncidentInfo(selectedIncidents[1]))}}>Merge</Button>
                </Modal.Footer>
            </Modal>);
      //}


    }

    mergeItems(item1, item2) {
      const param = IncidentService.sharedInstance.mergeIncidents(item1,item2);

      param.sub_user_id = this.state.sub_user_id;
      this.setState({isMergingIncidents: true,});
      IncidentService.sharedInstance.mergeCustomIncidents(param)
        .then(() => {
            ToastStore.success( "Incident successfully merged!");
            this.props.fetchIncidents();
            this.props.setShowMergeModal(false);
            this.setState({
                isMergingIncidents: false,
                selectedIncidents: [],
            });
        }).catch((err)=>{
            this.setState({
                isMergingIncidents: false,
            });
            ToastStore.error( "Merge incidents failed.");
        });
    }

    countSelectedIncidents() {
      return this.state.selectedIncidents.length
    }

    fetchIncidentHistory(id) {
        //this.setState({loadingHistory:true});
        IncidentService.sharedInstance.getHistory(id)
        .then((response)=>{
            let history = response.data;
            this.historyData = [];
            if(history != null) {
              history.map((item)=>{
                  let firstName = "";
                  let lastName = "";
                  let user = "";
                  try{
                    user = UtilsService.sharedInstance.isUndefinedOrNull(item.log.user) ? "" :item.log.user;
                    firstName = UtilsService.sharedInstance.isUndefinedOrNull(item.log.user.first_name) ? "" : item.log.user.first_name;
                    lastName = UtilsService.sharedInstance.isUndefinedOrNull(item.log.user.last_name) ? "" : item.log.user.last_name;

                  }
                  catch(e){}

                  var item_data = {
                      "user": firstName + " " + lastName,
                      "date": item.timestamp,
                      "time": item.timestamp,
                      "action": item.log.action,
                      "user_data":user,
                      "incident_data": item.log.incident
                  }

                  this.historyData.push(item_data);
              });
              this.setState({historyData: this.historyData});
            }

            //this.setState({loadingHistory:false});
        });
    }}

export default IncidentArchive;
